<template>
  <v-container fluid>
    <v-data-table class="background" :headers="headers" :items="groups" hide-default-footer>
      <template v-slot:item.actions="{ item }">
        <v-btn @click="goToGroupDetails(item)" class="my-2" elevation="0" small fab color="primary">
          <v-icon small>mdi-settings</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>Create Location Group</v-card-title>
        <v-card-text>
          <v-text-field v-model="newGroup.name" label="Group Name"></v-text-field>
          <v-textarea v-model="newGroup.description" label="Group Description"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" text class="text-capitalize" color="primary">Cancel</v-btn>
          <v-btn @click="createNewLocationGroup" class="text-capitalize" color="primary">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="dialog = true" fab fixed dark bottom right color="primary" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Create group</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { LocationGroupAPI } from '@/clients/locationGroups/locationGroups.api'
import { EventBus } from '@/event-bus'

export default {
  components: {
  },
  data() {
    return {
      dialog: false,
      search: '',
      newGroup: {
        name: '',
        description: ''
      },
      groups: [],
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
          align: ''
        },
        {
          text: 'Description',
          value: 'description',
          sortable: false,
          align: ''
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ]
    }
  },
  async mounted() {
    await this.fetchLocationGroups()
    EventBus.$on('fetch-mounting-methods', async () => {
      await this.fetchLocationGroups()
    })
  },
  methods: {
    async fetchLocationGroups() {
      let response
      try {
        response = await LocationGroupAPI.getAllLocationGroups()
      } catch (error) {
        this.groups = []
      }
      this.groups = response.data.payload
    },
    async createNewLocationGroup() {
      let response
      try {
        response = await LocationGroupAPI.createLocationGroup(this.newGroup)
      } catch (error) {
        this.groups = []
        return console.log(error)
      }
      this.dialog = false
      this.$router.push({ path: `/location-group-profile/${response.data.payload.id}/details` })
      this.swal({ title: 'Success!', text: 'Location group created successfully', timer: 3000 })
    },
    goToGroupDetails(group) {
      this.$router.push({ path: `/location-group-profile/${group.id}/details` })
    }
  }
}
</script>

<style>
</style>
